import React, { useState, FC, useEffect, useContext } from 'react';
import { AppContext } from '../context/AppContext';
import { getMyNotifications } from '../services/notification';
import { getAllowedRoutes } from '@/services/profile';
import { AuthContext } from '@/context/AuthContext';

interface Props {
  children: JSX.Element;
  user: any;
}

interface RoutePermission {
  asset_name: string;
  perm: string[];
}

export const AppProvider: FC<Props> = ({ children, user }) => {
  const [isSideNavOpen, setIsSideNavOpen] = useState<boolean>(
    localStorage.getItem('sidebarOpen') === 'true'
  );
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState<number>(0);
  const [allowedRoutes, setAllowedRoutes] = useState<string[]>([]);
  const [isBrandAdmin, setIsBrandAdmin] = useState<boolean>(false);
  const { profileInfo } = useContext(AuthContext);

  useEffect(() => {
    if (profileInfo?.userId) {
      (async () => {
        let response;

        try {
          response = await getMyNotifications(profileInfo?.userId);
        } catch (err) {
          console.error('error fetching notifications details', err);
        }
        if (response && response.unread_count) {
          setUnreadNotificationsCount(response.unread_count);
        }
      })();
    }
  }, [profileInfo]);

  useEffect(() => {
    const fetchAllowedRoutes = async () => {
      setAllowedRoutes(await getAllowedRoutes());
      let response: RoutePermission[];
      try {
        response = await getAllowedRoutes();
        const routesMap = {
          power_bi_dashboard: '/dashboard',
          elysia_sandbox: '/sandbox',
          brand_configuration: '/brand-configuration',
        };

        const allowedRoutes: string[] = [];
        response.forEach((asset) => {
          if (asset.perm.includes('read') || asset.perm.includes('write')) {
            allowedRoutes.push(routesMap[asset.asset_name]);
            if (asset.asset_name === 'brand_agent' && asset.perm.includes('create')) {
              allowedRoutes.push(routesMap['brand_configuration']);
              setIsBrandAdmin(true);
            }
          }
        });

        setAllowedRoutes(allowedRoutes);
      } catch (err) {
        console.error(`error fetching allowed routes`, err);
      }
    };
    fetchAllowedRoutes();
  }, []);

  const appContext: AppContextStore = {
    isSideNavOpen,
    isTouchDevice,
    unreadNotificationsCount,
    allowedRoutes,
    isBrandAdmin,
    setIsSideNavOpen,
    setIsTouchDevice,
    setUnreadNotificationsCount,
    setAllowedRoutes,
    setIsBrandAdmin,
  };

  return <AppContext.Provider value={appContext}>{user ? children : ''}</AppContext.Provider>;
};
